<!-- Bulk Upload Overlay -->
@if (isOpen) {
<div
  class="bulk-upload-overlay"
  (click)="doClose()"
  role="dialog"
  aria-modal="true"
>
  <div
    class="bulk-upload-panel"
    (click)="$event.stopPropagation()"
    tabindex="0"
  >
    <!-- Header -->
    <header class="bulk-upload-header">
      <h2 class="title">Bulk Upload</h2>
      <button class="close-btn" (click)="doClose()" aria-label="Close dialog">
        <i class="pi pi-times"></i>
      </button>
    </header>
    <!-- Body -->
    @if (!userCreationViewCtrl.showTable) {
    <main class="bulk-upload-body">
      <section class="upload-info">
        <p class="desc">
          Upload a file to create multiple users at once. Please note:
        </p>
        <ul class="guidelines">
          <li>Only "Employee" or "Admin" roles will be created via bulk upload.</li>
          <li>
            Use the sample Excel template
            <a class="link" (click)="getBulkUserTemplate()">click here</a>.
          </li>
          <li>All fields are mandatory.</li>
          <li>Recheck your file before uploading to avoid errors.</li>
        </ul>
      </section>
      <!-- Dropzone -->
      <div
        class="dropzone"
        [class.dragging]="dragging"
        (drop)="onDrop($event)"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
      >
        <input
          type="file"
          (change)="onExcelFileChoosen($event)"
          #excelFile
          [attr.accept]="accept"
          multiple
          id="fileInput"
        />
        <label for="fileInput" class="dropzone-label">
          <i class="pi pi-cloud-upload icon"></i>
          <div class="text">
            <strong>Drag & drop files here</strong> or click to browse
          </div>
          <small>Supported: XLS, XLSX (max {{ maxFileSizeMB }} MB)</small>
        </label>
      </div>
      <!-- Files List -->
      @if (files.length > 0) {
      <section class="files-section">
        <div class="files-header">
          <h3 class="sub-title">Selected Files</h3>
          <button class="clear-btn" (click)="clearAll()">
            <i class="pi pi-times"></i> Clear
          </button>
        </div>
        <ul class="file-list">
          @for (f of files; track f) {
          <li [class.error]="f.error">
            <div class="file-info">
              <div class="meta">
                <p class="file-name">{{ f.file.name }}</p>
                <p class="file-size">{{ f.sizeLabel }}</p>
                @if (f.error) {
                <p class="error-msg">{{ f.error }}</p>
                }
                <!-- <span>{{this.excelFileList?.name}}</span> -->
              </div>
            </div>
          </li>
          }
        </ul>
      </section>
      }
    </main>
    }
    <!-- Data Preview -->
    @if (userCreationViewCtrl.showTable) {
    <section class="preview-section">
      <div class="info-banner">
        <i class="pi pi-info-circle"></i>
        Review the uploaded data before saving.
      </div>
      @if (excelUserList.length > 0) {
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>#</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Phone</th>
              <!-- <th>Gender</th> -->
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            @for (user of excelUserList; track user; let i = $index) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ user.first_name }}</td>
              <td>{{ user.last_name }}</td>
              <td>{{ user.email_id }}</td>
              <td>{{ user.phone_no }}</td>
              <!-- <td>{{ user.gender }}</td> -->
              <td>
                <button
                  class="icon-btn danger"
                  (click)="removeUserFromListHandler(user)"
                  title="Remove user"
                >
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      }
    </section>
    }
    <!-- Footer -->
    <footer class="bulk-upload-footer">
      @if (!userCreationViewCtrl.showTable) {
      <button class="btn btn-outline" (click)="doClose()">Cancel</button>
      <button class="btn btn-primary" (click)="onUploadFileProcess()">
        Upload
      </button>
      } @if (userCreationViewCtrl.showTable) {
      <button class="btn btn-outline" (click)="cancelUserList()">Cancel</button>
      <button
        class="btn btn-primary"
        [class.loading]="userCreationViewCtrl.startUpload"
        (click)="createBulkUser()"
        [disabled]="userCreationViewCtrl.startUpload"
      >
        Save User Data
      </button>
      }
    </footer>
  </div>
</div>
}
